<template>
  <svg
    :height="size"
    :width="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21,9 C22.1045695,9 23,9.8954305 23,11 L23,13 C23,14.1045695 22.1045695,15 21,15 L21,16 C21,17.1045695 20.1045695,18 19,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,8 C1,6.8954305 1.8954305,6 3,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,9 Z M3,8 L3,16 L19,16 L19,8 L3,8 Z"
      fill-rule="evenodd"
    />
    <rect
      v-for="n in blocks"
      :key="n"
      :x="4 + (n - 1) * 5"
      y="9"
      width="4"
      height="6"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    blocks: {
      type: Number,
      default: 3,
    },
    color: {
      type: String,
      default: "green",
    },
    background: {
      type: String,
      default: "none",
    },
    size: {
      type: String,
      default: "25",
    },
  },
};
</script>
